<template>
  <div>
    <div style="padding-top: 5px">
      <el-form inline size="small" :model="form">
        <el-form-item label="时间范围">
          <DateRangePicker ref="qdDataRangePicker" :rangeDays="31" :startDate="startDate" :endDate="endDate" :getDateRange="changeDate" :clearable="false"></DateRangePicker>
        </el-form-item>
        <ChannelSelect :getChannelData="getChannelData"></ChannelSelect>
        <!-- <AgentStructure
        :showAgentGroup="true"
        :showAgent="false"
        :getAgentData="getAgentData"/> -->
        <el-form-item>
          <el-button type="primary" @click="search">查 询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="exportQueueDetail()">导 出</el-button>
        </el-form-item>
      </el-form>
      <MyProgress progressTitle="导出排队明细" :progressTaskId="progressTaskId" ref="exprtProgress" :progressFinish="exprotFinish"></MyProgress>
    </div>
    <el-row>
      <el-table :data="tableData" :header-cell-style="{
          background: '#f5f5f5',
          borderRight: '1px solid #fff',
          textAlign: 'center',
          height: '44px',
          lineHeight: '18px',
          fontWeight: 'normal',
          color: '#333',
        }" class="table-main">
        <el-table-column prop="visitorId" align="center" min-width="250px" label="访客ID" sortable></el-table-column>
        <el-table-column prop="visitorName" align="center" min-width="150px" label="访客名称" sortable></el-table-column>
        <el-table-column prop="enQueueTime" align="center" min-width="150px" label="进入排队时间" sortable></el-table-column>
        <el-table-column prop="accessTime" align="center" min-width="150px" label="进入咨询时间" sortable></el-table-column>
        <el-table-column prop="leaveMsgTime" align="center" min-width="150px" label="进入留言时间" sortable></el-table-column>
        <el-table-column prop="leaveQueueTime" align="center" min-width="150px" label="排队放弃时间" sortable></el-table-column>
        <el-table-column prop="queueTime" align="center" min-width="120px" label="排队时间" sortable></el-table-column>
      </el-table>
      <div class="table-page">
        <el-pagination class="work-mt20 work-mb20" @current-change="handleCurrentChange" :current-page="form.page" :page-size="form.limit" layout="total, prev, pager, next, jumper" :total="totalPage">
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>

<script>
import ChannelSelect from '@/views/workreport/components/public/ChannelSelect'
// import AgentStructure from '@/views/workreport/components/public/AgentStructure'
import MyProgress from '@/views/myprogress/MyProgress.vue'
import DateRangePicker from '@/views/workreport/components/public/DateRangePicker'
import { getQueueDetailReport, exportQueueDetailReport, downExcelFile } from '@/api/report'
import fileDownload from 'js-file-download'
import moment from 'moment'

export default {
  name: '',
  data() {
    return {
      form: {
        page: 1,
        limit: 10
      },
      timeRange: [],
      totalPage: 0,
      tableData: [],
      defaultTime: [],
      dims: {},
      endDate: new Date(new Date(moment().locale('zh-cn').format('YYYY-MM-DD') + ' 23:59:59')),
      startDate: new Date(new Date(moment().locale('zh-cn').format('YYYY-MM-DD') + ' 00:00:00') - 1000 * 60 * 60 * 24 * 30),
      progressTaskId: 'export-queue-detail'
    }
  },
  props: [],
  components: {
    MyProgress,
    DateRangePicker,
    ChannelSelect/* ,
    AgentStructure */
  },
  mounted() {
    this.timeRange = [this.startDate, this.endDate]
    this._getQueueDetailReport()
  },
  methods: {
    search() {
      this.form.page = 1
      this._getQueueDetailReport()
    },
    exportQueueDetail() {
      const self = this
      exportQueueDetailReport({ targetDims: this.dims, startTime: this.timeRange[0], endTime: this.timeRange[1], progressId: this.progressTaskId }).then(
        res => {
          self.$refs.exprtProgress.startProgress()
        }
      )
    },
    exprotFinish(data) {
      downExcelFile({ excelName: data.fileName }).then(res => {
        fileDownload(res, data.fileName)
      })
    },
    changeDate(data) {
      if (data == null) {
        this.timeRange = [new Date(new Date(moment().locale('zh-cn').format('YYYY-MM-DD') + ' 00:00:00') - 1000 * 60 * 60 * 24 * 30), new Date(new Date(moment().locale('zh-cn').format('YYYY-MM-DD') + ' 23:59:59'))]
        this.$refs.qdDataRangePicker.formatDate(this.timeRange[0], this.timeRange[1])
      } else {
        this.timeRange = data
      }
    },
    getAgentData(data) {
      console.log(data)
    },
    getChannelData(data) {
      this.dims = data
    },
    handleCurrentChange(page) {
      this.form.page = page
      this._getQueueDetailReport()
    },
    _getQueueDetailReport() {
      getQueueDetailReport({ targetDims: this.dims, page: this.form.page, limit: this.form.limit, startTime: this.timeRange[0], endTime: this.timeRange[1] })
        .then(res => {
          if (res.code === 2000) {
            this.tableData = res.data.data
            this.totalPage = res.data.total
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(() => { })
    }
  }
}
</script>
<style lang="scss" scoped>
.el-form--inline {
  ::v-deep .el-form-item {
    margin-bottom: 10px !important;
    margin-right: 20px;
  }
  ::v-deep .el-form-item__label {
    padding: 0 6px 0 0;
  }
  ::v-deep .el-form-item .el-form-item {
    margin-bottom: 0px !important;
    margin-right: 20px;
  }
  ::v-deep .el-form-item .el-form-item:last-child {
    margin-right: 0px;
  }
  ::v-deep .el-form-item:nth-last-child(2) {
    margin-right: 10px;
  }
}
</style>
